import React from "react";
import img from "../../img_project/webp/19Auvent textile architectural pour espace public et zones piétonnes.webp";
import img2 from ".././../img_project/webp/project5/2.webp";
import img3 from ".././../img_project/webp/project5/3.webp";
import img4 from ".././../img_project/webp/project5/4.webp";
import img1 from ".././../img_project/webp/project5/1.webp";
import img5 from ".././../img_project/webp/project5/5.webp";






const Block = ({ title, children }) => (
  <section className="pj-block">
    <h2>{title}</h2>
    <div className="pj-block-content">{children}</div>
  </section>
);

export default function ProjectCanopeeEcoleAmericaine() {
  return (
    <div className="pj-page">

      {/* HERO */}
      <section className="pj-hero">
        <div className="pj-hero-text">
          <span className="pj-badge">PROJET RÉFÉRENCE</span>
          <h1>Canopée – École Américaine <br/> Voiles d’ombrage & Pergolas</h1>

          <p>
            Conception et installation d’une canopée architecturale pour
            l’École Américaine, visant à créer des espaces extérieurs
            ombragés, confortables et esthétiques.
          </p>

          <p className="pj-sub">
            Solutions UNIK SYSTEM : Voiles d’ombrage, pergolas
            architecturales et structures métallo-textiles.
          </p>

          <div className="pj-hero-actions">
            <a className="btn-primarya" href="/devis">
              Demander un devis
            </a>
            <a
              href="/docs/fiche-projet-canopee-ecole-americaine.pdf"
              download
              className="btn-outline"
            >
              Télécharger la fiche projet
            </a>
          </div>
        </div>

        <div className="pj-hero-img">
          <img src={img} alt="Canopée École Américaine" />
        </div>
      </section>

      {/* CONTEXTE */}
      <Block title={<span style={{ color: "#EE2D2B" }}>Contexte du projet</span>}>
        <p>
          Dans le cadre de l’aménagement des espaces extérieurs de l’École
          Américaine, UNIK SYSTEM a réalisé une canopée en voiles
          d’ombrage sur structure métallique afin d’améliorer le confort
          thermique des usagers.
        </p>
        <p>
          Le projet devait allier performance d’ombrage, résistance aux
          conditions climatiques et intégration architecturale moderne.
        </p>
      </Block>

      {/* SOLUTIONS */}
      <Block title={<span style={{ color: "#EE2D2B" }}>Solutions UNIK SYSTEM</span>}>
        <ul className="pj-list">
          <li>Voiles d’ombrage haute performance</li>
          <li>Pergolas architecturales sur mesure</li>
          <li>Structure métallique thermolaquée</li>
          <li>Membranes textiles techniques</li>
          <li>Protection solaire extérieure</li>
          <li>Intégration architecturale premium</li>
        </ul>
      </Block>

      {/* RESULTATS */}
      <Block title={<span style={{ color: "#EE2D2B" }}>Résultats obtenus</span>}>
        <ul className="pj-list">
          <li>Espaces extérieurs confortables et ombragés</li>
          <li>Valorisation architecturale du campus</li>
          <li>Excellente tenue face aux conditions climatiques</li>
          <li>Design contemporain et léger</li>
          <li>Solution durable et esthétique</li>
        </ul>
      </Block>

      {/* GALERIE */}
      <Block title={<span style={{ color: "#EE2D2B" }}>Galerie projet</span>}>
        <div className="pj-gallery">
          <img src={img} alt="" />
          <img src={img1} alt="" />
          <img src={img2} alt="" />
          <img src={img3} alt="" />
          <img src={img4} alt="" />
          <img src={img5} alt="" />
        </div>
      </Block>

      {/* CTA */}
      <section className="pj-cta">
        <h2>Vous avez un projet similaire ?</h2>
        <p>
          Notre équipe technique vous accompagne de la conception à la pose.
        </p>
        <br />
        <a href="/contact" className="btn-primarya">
          Contactez-nous
        </a>
      </section>

    </div>
  );
}
